export default __webpack_public_path__ + "static/media/1.10889b9c.png";